import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{attrs:{"value":_vm.value,"persistent":"","width":"300"}},[_c(VCard,{attrs:{"dark":""}},[_c(VCardText,[_vm._v(" "+_vm._s(_vm.$t("modalLoaderText"))+" "),_c(VProgressLinear,{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }